<template>
  <span :class="spanClasses">
    <slot></slot>
  </span>
</template>

<script>
import { propValidationService } from '../functions';

const WEIGHT_TYPES = [{ key: 'normal' }, { key: 'lighter' }, { key: 'bolder' }];

const SIZE_TYPES = [{ key: 'sm' }, { key: 'md' }, { key: 'lg' }];

const COLOR_TYPES = [{ key: 'grey' }, { key: 'blue' }, { key: 'white' }, { key: 'grey-semi-light' }, { key: 'green' }];

export default {
  name: 'dx-text',
  props: {
    weight: {
      default: 'normal',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: WEIGHT_TYPES.map((attr) => attr.key),
        errorMessage: 'You should inform a valid weight',
      }),
    },
    size: {
      default: 'md',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: SIZE_TYPES.map((attr) => attr.key),
        errorMessage: 'You should inform a valid size',
      }),
    },
    color: {
      default: 'grey',
      type: String,
      validator: propValidationService.buildValidator({
        validValues: COLOR_TYPES.map((attr) => attr.key),
        errorMessage: 'You should inform a valid color',
      }),
    },
  },
  computed: {
    spanClasses() {
      return {
        'dx-text': true,
        [this.weight]: this.weight !== 'normal' ? this.weight : false,
        [this.size]: true,
        [this.color]: this.weight !== 'grey' ? this.weight : false,
      };
    },
  },
};
</script>

<style scoped lang="scss">
span {
  padding: 0 var(--dx-space-size--xs);
}

.bolder {
  font-weight: bolder;
}

.sm {
  font-size: var(--dx-text-size--sm);
}

.md {
  font-size: var(--dx-text-size--md);
}

.lg {
  font-size: var(--dx-text-size--lg);
}

.blue {
  color: var(--dx-color--blue-semi-light);
}

.grey {
  color: var(--dx-color--grey-dark);
}

.grey-semi-light {
  color: var(--dx-color--grey);
}

.green {
  color: var(--dx-color--green);
}

.white {
  color: var(--dx-color--white);
}
</style>
